import { get, post, put, del } from './apiMethods';
import {utc} from '../libs/date';
import {token} from '../libs/localStorage';

export const fetchFolders = get.bind(this, 'folder');

export const saveFolder = (json) => {
  console.log('TODO: saveFolder', json);
};

export const auth = {
  login: (username, password, captcha) => (
    // (captcha ? post('auth/login-captcha', { username, password, 'g-recaptcha-response': captcha }) : post('auth/login', { username, password }))
    post('auth/login', captcha ? { username, password, 'g-recaptcha-response': captcha } : { username, password })
      .then((res) => {
        token.setToken(res.token);
        return res.token;
      })
      .catch(err => {
        console.log(err);
        if (err && err.status === 401 && !!token.getEncoded()) {
          token.removeToken();
        }
        console.log(err.status, err.message);
        throw new Error(err.message);
      })
  ),
  logout: () => get('auth/logout')
};

const crud = (slug, service = 'api') => ({
  fetchAll: () => get(`${service}/${slug}`),
  fetchById: (id) => get(`${service}/${slug}/${id}`),
  create: (json) => post(`${service}/${slug}`, json),
  update: (id, json) => put(`${service}/${slug}/${id}`, json),
  remove: (id) => del(`${service}/${slug}/${id}`),
  removeMultiple: (ids) => post(`${service}/${slug}/delete`, { ids }),
});

export const transfer = {
  ...crud('observation-partition/transfer'),
  transferStart: (id) => get(`api/observation-partition/transfer/${id}/start`),
  transferStop: (id) => get(`api/observation-partition/transfer/${id}/stop`),
};

export const observationLookup = {
  fetchAll: () => get(`api/observation-partition/observation_lookup`),
};

export const station = {
  ...crud('station'),
  addDataOrigin: (id, json) => post(`api/station/${id}/data-origin`, json),
  updateDataOrigin: (id, dataOriginId, json) => put(`api/station/${id}/data-origin/${dataOriginId}`, json),
  removeDataOrigin: (id, dataOriginId) => del(`api/station/${id}/data-origin/${dataOriginId}`),
  fetchObservations: (stationId) => get(`api/station/${stationId}/observation`),
  addDataSeries: (stationId, json) => post(`api/station/${stationId}/data-series`, json),
  addAggregatedDataSeries: (stationId, json) => post(`api/station/${stationId}/aggregated-data-series`, json),
  updateDataSeriesItem: (stationId, dataSeriesId, json) => put(`api/station/${stationId}/data-series/${dataSeriesId}`, json),
  updateAggregatedDataSeriesItem: (stationId, dataSeriesId, json) => put(`api/station/${stationId}/aggregated-data-series/${dataSeriesId}`, json),
  removeDataSeriesItem: (stationId, dataSeriesId) => del(`api/station/${stationId}/data-series/${dataSeriesId}`),
  fetchDataSeries: (stationId, filters) => {
    if (!filters) { return get(`api/station/${stationId}/data-series`); }
    const queries = Object.keys(filters)
      .map((key) => {
        return `${key}=${filters[key]}`;
      })
      .join('&');

    return get(`api/station/${stationId}/data-series?${queries}`);
  },
  fetchDataSeriesItem: (stationId, dataSeriesId) => get(`api/station/${stationId}/data-series/${dataSeriesId}`),
  fetchDataOrigins: (stationId) => get(`api/station/${stationId}/data-origin`),
  fetchDataOrigin: (stationId, dataOriginId) => get(`api/station/${stationId}/data-origin/${dataOriginId}`),
  fetchMonitorings: (stationId) => get(`api/station/${stationId}/monitoring`),
  fetchMetaData: (stationId) => get(`api/station/${stationId}/meta-data`),
  fetchMetaDataAudit: (stationId) => get(`api/station/meta-data-audit/${stationId}`),
  updateMetaData: (stationId, json) => put(`api/station/${stationId}/meta-data`, json),
  fetchParameters: (stationId) => get(`api/station/${stationId}/parameter`),
  fetchQcChecks: (stationId) => get(`api/station/${stationId}/qc-check`),
  saveQcChecks: (stationId, json) => post(`api/station/${stationId}/qc-check`, json),
  fetchWindRoseStations: () => get('api/wind-rose/station'),
  fetchWindRoseObservation: (stationId, date_from, date_to) => get(`api/station/${stationId}/wind-rose?date_from=${utc(date_from)}&date_to=${utc(date_to)}`),
  imageRemove: (stationId, imageId) => post(`api/station/${stationId}/image/delete`, {imageId:imageId}),
  ftp: {
    fetchById: (stationId) => get(`api/station/ftp/${stationId}/config`),
    update: (stationId, json) => put(`api/station/ftp/${stationId}/config`, json),
    fetchData: (stationId, {date_from, date_to}) => get(`api/station/ftp/${stationId}/files?date_from=${date_from}&date_to=${date_to}`),
  },
  fetchLocation: (station_id, filters) => get(`api/station/${station_id}/location?date_from=${utc(filters.date_from)}&date_to=${utc(filters.date_to)}`),
};
export const folder = crud('folder');
export const unit = crud('unit');
export const user = crud('user');
export const user_preference = {
  fetchAll: () => get(`api/user_preference`),
  update: (id, json) => put(`api/user_preference/${id}`, json),
};
export const parameter = crud('parameter');
export const parameterUnit = crud('parameter-unit');
export const parameterType = crud('parameter-type');
export const request = {
  ...crud('request'),
  fetchRawDataByRequestId: (id) => get(`api/request/${id}/raw-data`, { id }),
  generateObservationByRequestId: (id) => post(`api/request/${id}/observation`, { id }),
  fetchAllRawData : ({origin_code, parameter_code, date_from, date_to, fetchIndex}) => get(`api/request/raw-data?origin_code=${origin_code}&parameter_code=${parameter_code}&date_from=${utc(date_from)}&date_to=${utc(date_to)}&fetchIndex=${fetchIndex}`)
};
export const dataSource = {
  ...crud('data-source'),
  template: {
    fetchParameterTemplate: id => get(`api/data-source/${id}/parameter-template`),
    createParameterTemplate: (id, json) => post(`api/data-source/${id}/parameter-template`, json),
  }
};
export const dataOrigin = crud('data-origin');
export const dataOriginParameter = crud('data-origin-parameter');
export const dataSeries = {
  ...crud('data-series'),
  updateQCRules: (dataSeriesId, qcRuleIds) =>
    put(`api/data-series/${dataSeriesId}/qc-rule`, qcRuleIds),
};
export const metaData = crud('meta-data');
export const metaDataTemplate = crud('meta-data-template');
export const qcCheck = {
  ...crud('qc-check', 'qc/api'),
  runManualQC: filters => get(`api/qc-check/manual?series_id=${filters.series_id}&date_from=${utc(filters.date_from)}&date_to=${utc(filters.date_to)}&qc_type=${filters.qc_type}`),
  fetchStationQcRules: station_id => get(`qc/api/station/${station_id}/rule`),
  fetchCheckLogs: ({station_id, series_id, rule_id, date_from, date_to}) => get(`qc/api/station/rule/check_log?station_id=${station_id}&series_id=${series_id}&rule_id=${rule_id}&date_from=${utc(date_from)}&date_to=${utc(date_to)}`)
};
export const qcRule = crud('qc-rule');
export const qcType = crud('qc-type');
export const qcFlag = crud('qc-flag', 'qc/api');
export const monitoring = crud('monitoring');
export const tabular = crud('tabular');

export const observation = {
  fetchAll: (filters) => get(`api/observation?series_id=${filters.series_id}&date_from=${utc(filters.date_from)}&date_to=${utc(filters.date_to)}`),
  fetchObservationsWithQCValues: ({series_id, date_from, date_to}) => get(`api/observation/index?series_id=${series_id}&date_from=${utc(date_from)}&date_to=${utc(date_to)}`),
  fetchIndex: filters => get(`api/observation/index?${filters.series_id?`series_id=${filters.series_id}`:`station_id=${filters.station_id}`}&date_from=${utc(filters.date_from)}&date_to=${utc(filters.date_to)}`),
  updateMultiple : json => put('api/observation', json),
  fetchAggregatedData: filters => get(`api/aggregation/observation?series_id=${filters.series_id}&aggregation_id=${filters.aggregation_id}&date_from=${utc(filters.date_from)}&date_to=${utc(filters.date_to)}`),
};
export const analysis = {
  fetchAll: (filters) =>
    get(`api/analysis?series_id=${filters.series_id}` +
      `&date_from=${utc(filters.date_from)}&date_to=${utc(filters.date_to)}` +
      `&station_id=${filters.station_id}&period=${filters.period}`),
  fetchMore: ({stations, parameters, date_from, date_to, show_qc, use_tag, tag_id, returnMetaData}) =>
    get(`api/analysis/more?stations=${stations || ''}&parameters=${parameters || ''}&date_from=${utc(date_from)}&date_to=${utc(date_to)}&show_qc=${show_qc}&use_tag=${use_tag}&tag_id=${tag_id}&returnMetaData=${returnMetaData}`)
};
export const tag = {
  ...crud('tag'),
  parameterUpsert: (id, json) => post(`api/tag/${id}/parameter`, json)
};
export const role = {
  ...crud('role'),
  fetchPermissions: (roleId) => get(`api/role/${roleId}/permission`),
};
export const permission = crud('permission');
export const mapMarker = crud('map');

export const auto = {
  fetchStationDataSeries: (stationId) => get(`api/auto/station/${stationId}/data-series`),
  postStationDataSeries: (stationId) => post(`api/auto/station/${stationId}/data-series`),
};

export const inventoryManufacturer = crud('inventory/manufacturer');
export const inventorySupplier = crud('inventory/supplier');
export const inventoryProduct = {
  ...crud('inventory/product'),
  relatedFile: {
    remove: (productId, fileId) => del(`api/inventory/product/${productId}/related-file/${fileId}`),
    removeMultiple: (productId, fileIds) => post(`api/inventory/product/related-file/delete`, { productId, fileIds }),
  },
  image: {
    remove: (productId, fileId) => post(`api/inventory/product/${productId}/image/delete`, { fileId })
  }
};
export const inventoryItem = {
  ...crud('inventory/item'),
  relatedFile: {
    remove : (itemId,fileId) => del(`api/inventory/item/${itemId}/related-file/${fileId}`)
  },
  movement: {
    add : (itemId, json) => post(`api/inventory/item/${itemId}/movement`, json),
    get : (itemId) => get(`api/inventory/item/${itemId}/movement`)
  }
};
export const inventoryPcategory = crud('inventory/pcategory');
export const stationInventory = {
  item: {
    list: (stationId) => get(`api/station/${stationId}/inventory/item`),
    add: (stationId, itemIds) => post(`api/station/${stationId}/inventory/item/add`, { item_ids: itemIds }),
    remove: (stationId, itemIds) => post(`api/station/${stationId}/inventory/item/remove`, { item_ids: itemIds }),
  },
};

export const daqProcessor = {
  fetchAll: () => get(`daq/daq-processor`),
  fetchById: (id) => get(`daq/daq-processor/${id}`),
  create: (json) => post(`daq/daq-processor`, json),
  update: (id, json) => put(`daq/daq-processor/${id}`, json),
  remove: (id) => del(`daq/daq-processor/${id}`),
  removeMultiple: (ids) => post(`daq/daq-processor/delete`, { ids }),
};
export const daqLocation = {
  fetchAll: () => get(`daq/location`),
  fetchById: (id) => get(`daq/location/${id}`),
  create: (json) => post(`daq/location`, json),
  update: (id, json) => put(`daq/location/${id}`, json),
  remove: (id) => del(`daq/location/${id}`),
  removeMultiple: (ids) => post(`daq/location/delete`, { ids }),
};

export const dataOriginParameterTemplate = {
  fetchAll: () => get(`daq/origin-parameter-template`),
  fetchById: (id) => get(`daq/origin-parameter-template/${id}`),
  create: (json) => post(`daq/origin-parameter-template`, json),
  update: (id, json) => put(`daq/origin-parameter-template/${id}`, json),
  remove: (id) => del(`daq/origin-parameter-template/${id}`),
  removeMultiple: (ids) => post(`daq/origin-parameter-template/delete`, { ids }),
};

export const userPermission = {
  fetchAll: () => get(`api/user-permission`),
  create: (json) => post('api/user-permission', json),
  remove: (json) => del('api/user-permission', json),
  fetchDefaultPermissions: () => get('api/user-permission/def_res'),
  station: {
    fetchAll: () => get(`api/user-permission/station`),
    fetchById: (id) => get(`api/user-permission/station/${id}`),
    create: (json) => post(`api/user-permission/station`, json),
  },
  parameter: {
    fetchAll: () => get(`api/user-permission/parameter`),
    fetchById: (id) => get(`api/user-permission/parameter/${id}`),
    create: (json) => post(`api/user-permission/parameter`, json),
  },
  crudAccess: {
    fetchById: (id) => get(`api/user-permission/crud-access/${id}`),
    create: (json) => post(`api/user-permission/crud-access`, json),
  }
};

export const aggregation = {
  ...crud('aggregation'),
  fetchAggregationMethods: () => get('api/aggregation/method'),
  fetchAggregationIntervals: () => get('api/aggregation/interval'),
  runManualAggregation: json => post('api/aggregation/manual', Object.assign({}, {series_id: json.series_id, date_from: utc(json.date_from), date_to: (json.date_to)}))
};

export const dataDelivery = {
  export: {
    ...crud('data-delivery/export'),
    run: (id, date_from, date_to) => get(`api/data-delivery/export/${id}/run?date_from=${date_from}&date_to=${date_to}`)
  },
  rawExport: {
    ...crud('api/rd_export', 'rd_export'),
    audit: {
      fetchAll: (id) => get(`rd_export/api/rd_export/${id}/audit`),
    }
  },
  idaqExport: {
    ...crud('api/idaq_export', 'rd_export'),
    audit: {
      fetchAll: (id) => get(`/rd_export/api/idaq_export/${id}/audit`),
    }
  }
};

export const tools = {
  deleteObservation: {
    fetchObservation: ({stations, parameters, date_from, date_to, timestamp_from, timestamp_to, time, qc_flag}) => get(`api/obs-del/tools/observation?stations=${stations}&parameters=${parameters}&date_from=${utc(date_from)}&date_to=${utc(date_to)}&timestamp_from=${timestamp_from !== '' ? utc(timestamp_from): ''}&timestamp_to=${timestamp_to !== '' ? utc(timestamp_to): ''}&time=${time}&qc_flag=${qc_flag}`),
    deleteObservation: json => post('api/obs-del/tools/observation/delete', json),
    verifyLogin: (json) => post('auth/login', json)
  }
};

export const winhydro = {
  getAllAvailableStationIndexes: () => get(`winhydro/generic/station_indexes`),
  getDistinctTypeNumbersByStationIndex: (station_index) => get(`winhydro/generic/type_numbers?station_index=${station_index}`),
  getDistinctRatingTableListingsByStationIndex: (station_index) => get(`winhydro/generic/rating_table_listings?station_index=${station_index}`),
  getRatingTableEntriesByRatingTypeNoAndStationIndex: ({station_index, rating_type_no}) => get(`winhydro/generic/rating_table?station_index=${station_index}&rating_type_no=${rating_type_no}`),
  getAllRatingTableEntriesByStationIndex: (station_index) => get(`winhydro/generic/rating_table/all?station_index=${station_index}`),
  postRatingTable: (data) => post(`winhydro/generic/rating_table_listing`, data),
  updateRatingTable: (payload) => put(`winhydro/generic/rating_table`, payload),
  updateRatingTableListing: (payload) => put(`winhydro/generic/rating_table_listing`, payload),
  deleteRatingTableListing: (id) => del(`winhydro/generic/rating_table_listing/${id}`),
  getDischargeUsingRatingEquation: (payload) => post(`winhydro/rating-curve/discharge`, payload),
};

export const auditHistory = {
  getAuditHistory: (table_name, link) => get(`api/audit-trail?table_name=${table_name}&link=${link}`)
}

export const location = crud('location');
export const locationType = crud('location-type');
export const stationType = crud('station-type')
export const reportingTemplate = {
  ...crud('reporting/template'),
  columnTypes: crud('reporting/template-column-type'),
  report: {
    generate: (template_id, filters) => get(`api/reporting/report/${template_id}/generate?stations=${filters.stations || ''}&date_from=${utc(filters.date_from)}&date_to=${utc(filters.date_to)}`)
  }
}
export const reportingTemplateHeader = crud('reporting/header');
export const ratingEquation = {
  ...crud('rating-curve/curve', 'winhydro'),
  equation: {
    ...crud('rating-curve/equation', 'winhydro')
  },
  audit: {
    fetchAll: (id, eq_id) => get(`winhydro/rating-curve-audit/station-rating-equation/${id}/rating-equation/${eq_id}`),
  }
}



// WEBPACK FOOTER //
// ./src/actions/api.js